import { render, staticRenderFns } from "./QuantityProductForm.vue?vue&type=template&id=5327a333&scoped=true&"
import script from "./QuantityProductForm.vue?vue&type=script&lang=js&"
export * from "./QuantityProductForm.vue?vue&type=script&lang=js&"
import style0 from "./QuantityProductForm.vue?vue&type=style&index=0&id=5327a333&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5327a333",
  null
  
)

export default component.exports